var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.875 28.8753L22.9034 22.9037M22.9034 22.9037C23.9249 21.8822 24.7352 20.6695 25.288 19.3349C25.8408 18.0003 26.1253 16.5699 26.1253 15.1253C26.1253 13.6807 25.8408 12.2503 25.288 10.9157C24.7352 9.58104 23.9249 8.36838 22.9034 7.34691C21.8819 6.32544 20.6693 5.51516 19.3347 4.96235C18 4.40953 16.5696 4.125 15.125 4.125C13.6805 4.125 12.25 4.40953 10.9154 4.96235C9.5808 5.51516 8.36813 6.32544 7.34666 7.34691C5.28371 9.40986 4.12476 12.2078 4.12476 15.1253C4.12476 18.0427 5.28371 20.8407 7.34666 22.9037C9.40962 24.9666 12.2076 26.1256 15.125 26.1256C18.0425 26.1256 20.8405 24.9666 22.9034 22.9037Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.9e9ca41737bdc60f960e088b33158c0f.svg";
export { ForwardRef as ReactComponent };